export const ACCOUNT_DELETION_CONFIRMATION = "DELETE";

export const ACCOUNT_DELETION_REASONS = [
  { value: "not_useful", label: "Artha is not useful for me" },
  { value: "missing_features", label: "Features I need are missing" },
  { value: "too_difficult", label: "The product is difficult to use" },
  { value: "privacy_concerns", label: "I have privacy or data concerns" },
  { value: "technical_issues", label: "I experienced technical issues" },
  { value: "temporary_break", label: "I am taking a break" },
  { value: "other", label: "Other" },
] as const;

export const TALK_TO_CEO_CARD_IMAGE_URL = "/images/talk-to-ceo.png";

export const FEEDBACK_CARD_IMAGE_URL =
  "https://cdn-wp.artha.link/wp-content/uploads/2026/03/Manufacturing-1.svg";
